import { BankEffects } from './effects/bank.effects';
import { EventEffects } from './effects/event.effects';
import { GeneralSettingsEffects } from './effects/general.effects';
import { LoanerWheelInventoryEffects } from './effects/loaner-wheel-inventory.effects';
import { MasterDataEffects } from './effects/masterdata.effect';
import { OnboardingEffects } from './effects/onboarding.effects';
import { SiteEffects } from './effects/site.effects';
import { SoftwareEffects } from './effects/software.effects';
import { SupplierRatingEffects } from './effects/supplier-rating.effect';
import { SupplierTaskEffects } from './effects/supplier-tasks.effects';
import { SupplierStateEffects } from './effects/supplierstate.effect';
import { TaxEffects } from './effects/tax.effects';

export const AppEffects = [
    MasterDataEffects,
    SupplierStateEffects,
    EventEffects,
    SoftwareEffects,
    GeneralSettingsEffects,
    SupplierRatingEffects,
    SiteEffects,
    LoanerWheelInventoryEffects,
    TaxEffects,
    OnboardingEffects,
    BankEffects,
    SupplierTaskEffects
]
